<template>
  <div class="wrapper">
    <div class="connent_wrapper"
         v-for="(item,index) in myScreenCaptureData"
         :key="index">
      <div class="img_wrapper"
           @click.stop="showImg(item.url)">
        <img :src="item.url"
             alt="">
      </div>
      <div class="select_wrapper">
        <a-select style="width: 120px"
                  :value="item.type"
                  @change="handleChange"
                  @select="handleSelect(item)">
          <a-select-option :value="-1">
            --
          </a-select-option>
          <a-select-option :value="0"
                           :disabled="isHaveUp()">
            上刊截屏
          </a-select-option>
          <a-select-option :value="1"
                           :disabled="isHaveDown()">
            下刊截屏
          </a-select-option>
          <a-select-option :value="2"
                           :disabled="isHaveFrames(item)">
            {{item.materialName+'截屏'}}
          </a-select-option>
        </a-select>
      </div>
      <div class="time_wrapper">
        <div class="date">
          {{item.createTime.split(" ")[0]}}
        </div>
        <div class="time">
          {{item.createTime.split(" ")[1]}}
        </div>
      </div>
    </div>
    <a-modal class="show_img"
             :visible="isShowBigImg"
             @cancel="handleCancel"
             @ok='handleCancel'
             :zIndex="1200"
             :footer="null"
             :width="390"
             :closable="false">
      <img :src="showUrl">
    </a-modal>
  </div>
</template>

<script>
import { api } from '../../../commomFun/api'
export default {
  name: 'ScreenCapture',
  props: {
    adPlanScreenShotInfo: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      isShowBigImg: false,
      showImgUrl: '',
      currentValue: '',
      showUrl: '',
      myScreenCaptureData: [],
    }
  },
  watch: {
    adPlanScreenShotInfo: {
      handler(newVal, oldVal) {
        //将被选中的日期渲染到视图上
        this.myScreenCaptureData = JSON.parse(JSON.stringify(newVal))
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    // 截屏列表数据
    //下拉选项 -- 上刊截屏 下看截屏 3个选项固定  其他的就画面名称+截屏
  },
  methods: {
    handleChange(value) {
      this.currentValue = value
    },
    handleSelect(item) {
      // 确认选定的画面
      let params = {
        planId: item.planId,
        pointId: item.pointId,
        type: this.currentValue,
        id: item.id,
      }
      //发送请求 this.currentValue 为当前改变的值
      //成功就将选定的值赋给item.value
      //成功后刷新表格
      api
        .postApi('/adMachineScreenShot/updateInfo', params)
        .then(({ data }) => {
          if (data.code == 200 && data.data) {
            item.type = this.currentValue
            this.$forceUpdate() //强刷
            // this.$emit('refresh') //刷新表格但是截屏状态也会消失
            this.$emit('changeInfo', { id: item.id, type: this.currentValue })
          } else {
            this.$message.error('更新截图信息失败')
          }
        })
    },
    //展示大图
    showImg(url) {
      this.isShowBigImg = true
      this.showUrl = url
    },
    //关闭弹窗
    handleCancel() {
      this.isShowBigImg = false
    },
    // 是否存在上刊
    isHaveUp() {
      return this.myScreenCaptureData.some((item) => {
        return item.type == 0
      })
    },
    //是否存在下刊
    isHaveDown() {
      return this.myScreenCaptureData.some((item) => {
        return item.type == 1
      })
    },
    //是否存在该画面截屏，存在名字相同并且
    isHaveFrames(i) {
      return this.myScreenCaptureData.some((item) => {
        return item.type == 2 && item.materialName == i.materialName
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  // justify-content: space-between;
  justify-content: center;
  flex-wrap: wrap;
  .connent_wrapper {
    position: relative;
    margin-bottom: 16px;
    .img_wrapper {
      margin-bottom: 6px;
      height: 120px;
      width: 120px;
      border-radius: 4px;
      cursor: pointer;
      img {
        height: 100%;
        width: 100%;
        border-radius: 4px;
      }
    }
    .time_wrapper {
      padding: 4px 0px;
      height: 38px;
      width: 120px;
      text-align: center;
      background: rgba(0, 0, 0, 0.05);
      border-radius: 4px;
      .date,
      .time {
        height: 16px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.65);
        line-height: 16px;
      }
    }
    .select_wrapper {
      border-radius: 4px;
      overflow: hidden;
      position: absolute;
      box-sizing: border-box;
      top: 94px;
      /deep/ .ant-select-selection {
        border: none;
        background-color: rgba(0, 0, 0, 0.5);
        text-align: center;
      }
      /deep/ .ant-select-selection {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      /deep/ .ant-select-selection--single {
        height: 26px;
      }
      /deep/ .ant-select-selection__rendered {
        display: block;
        height: 26px;
        padding: 0;
        margin: 0;
      }
      /deep/ .ant-select-arrow {
        position: static;
        // display: block;
        margin: 0;
        padding: 0;
        color: #fff;
        font-size: 12px;
        transform: translateY(2px);
      }
      /deep/ .ant-select-selection-selected-value {
        margin-right: 2px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        height: 26px;
        line-height: 26px;
        font-weight: 400;
        color: #ffffff;
      }
    }
  }
  .connent_wrapper:nth-child(2n) {
    margin-left: 12px;
  }
  .connent_wrapper:nth-last-child(2) {
    margin-bottom: 0;
  }
  .connent_wrapper:nth-last-child(1) {
    margin-bottom: 0;
  }
}
.show_img {
  /deep/ .ant-modal-body {
    padding: 0;
    // height: 560px;
  }
  img {
    height: 100%;
    width: 100%;
  }
}
</style>